// extracted by mini-css-extract-plugin
module.exports = {"title":"AddNewCategory_title__3qvcW","row":"AddNewCategory_row__NvsXO","btns":"AddNewCategory_btns__3qg-y"};